import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Button} from 'react-bootstrap';
import { AiOutlineDownload } from 'react-icons/ai';
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { BsTrash } from 'react-icons/bs';
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { IoArrowUndoOutline } from "react-icons/io5";
import { TbTrashOff } from "react-icons/tb";

// pagina fondamentale per il check dei documenti         {/* idroslab  */}
const { Data_formattata1 } = require('./Funzioni_comuni_data_formattata')
const { Controlla_se_lavoro_in_debug } = require('./Funzioni_comuni_3')

const Visualizza_lista_documenti_pdf = (props) => {
//    const [somma, calcola_somma] = useState('');

const { user, isAuthenticated } = useAuth0();
const [lista_documentazione_temporanea_alunni, SET_lista_documentazione_temporanea_alunni] = useState(null);


const Approva_pdf = (id_array, booleano, tutor_id) => {
    let stringa_per_chiamata_server
    if (props.attore_tipo === 'ditta') {
        stringa_per_chiamata_server = '/ditte/attore_approva_pdf/'
    } 
    if (props.attore_tipo === 'alunno') {
        stringa_per_chiamata_server = '/alunni/attore_approva_pdf/'
    } 
    if (props.attore_tipo === 'progetto') {
        stringa_per_chiamata_server = '/progetti/attore_approva_pdf/'
    } 

    axios.patch(stringa_per_chiamata_server + id_array + '/' + booleano + '/' + tutor_id)
        .then((res) => {
            console.log(res.data)

        }).catch((error) => {
            console.log(error)
        });
    //        props.SET_variab_aggiorna(!aux)
    props.SET_variab_aggiorna(current => !current)
}

const cancella_url = (id_array, booleano) => {
    let stringa_per_chiamata_server
    if (props.attore_tipo === 'ditta') { 
        stringa_per_chiamata_server = '/ditte/attore_metti_pdf_nel_cestino/'
    } 
    if (props.attore_tipo === 'alunno') {
        stringa_per_chiamata_server = '/alunni/attore_metti_pdf_nel_cestino/'
    } 
    if (props.attore_tipo === 'progetto') {
        stringa_per_chiamata_server = '/progetti/attore_metti_pdf_nel_cestino/'
    } 

    axios.patch(stringa_per_chiamata_server + id_array + '/' + booleano)
    .then((res) => {
        console.log(res.data)

    }).catch((error) => {
        console.log(error)
    });
    //        props.SET_variab_aggiorna(!aux)
    props.SET_variab_aggiorna(current => !current)
}


const cancella_documento_definitivo = (id, id_array) => {
    let stringa_per_chiamata_server
    if (props.attore_tipo === 'ditta') {
        stringa_per_chiamata_server = '/ditte/attore_cancella_documento/'
    } 
    if (props.attore_tipo === 'alunno') {
        stringa_per_chiamata_server = '/alunni/attore_cancella_documento/'
    } 
    if (props.attore_tipo === 'progetto') {
        stringa_per_chiamata_server = '/progetti/attore_cancella_documento/'
    } 
    axios.patch(stringa_per_chiamata_server + id + '/' + id_array)
    .then((res) => {
        console.log(res.data)

    }).catch((error) => {
        console.log(error)
    });
    //        props.SET_variab_aggiorna(!aux)
    props.SET_variab_aggiorna(current => !current)
}



const ottieni_url = (indirizzo) => {
    axios.get('/transfer_s3/pdf_ottieni_url/' + indirizzo)
        .then((res) => {
            console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
            console.log(res.data)

            const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
            return res.data

        }).catch((error) => {
            console.log('ottieni_url url errore')

            console.log(error)
        });
        props.SET_variab_aggiorna(current => !current)
    };



    const Prepara_certificati_formazione = (indirizzo) => {
        console.log('Prepara certificati' + indirizzo)
        axios.get('/classi/prepara_certificati_formazione/' + props.attore._id + '/' + user.email + '/' + indirizzo)
        .then((res) => {
            console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
            console.log(res.data)
            if (Array.isArray(res.data)) {
                console.log(res.data)
                SET_lista_documentazione_temporanea_alunni(res.data)
//                props.SET_variab_aggiorna(current => !current)

            }

        }).catch((error) => {
            console.log('ottieni_url url errore')

            console.log(error)
        });
  
//        props.SET_variab_aggiorna(current => !current)
    };


    function colorazione(tipo_corto) {
            var hStyle = { color: 'red', margin: '5px', padding: '5px' };
            return hStyle;
    }


    return (
    <>
    {props.attore.documentazione_array.map(function (item2, index2) {
                         
        //                                        var aux = ottieni_url(props.item2.indirizzo_S3)
        if (props.tipologia_documento == item2.tipologia_documento) {

        if (!item2.cestino || Controlla_se_lavoro_in_debug(user)) {    
        return <>
        <tr class={item2.cestino && "table-secondary"}>
            <td> {index2 + 1} </td>
            <td class={item2.cestino && "text-muted"}> 
            {!props.tipologia_documento.includes('formazione') && props.tipologia_documento} 
            {props.tipologia_documento === 'formazione_A' && 'Formazione Rischio Basso' }
            {props.tipologia_documento === 'formazione_B' && 'Formazione Rischio Medio' }
            {props.tipologia_documento === 'formazione_C' && 'Formazione Rischio Alto' } &nbsp;   &nbsp;

            </td>
            <td class={item2.cestino && "text-muted"}>     
                    {Data_formattata1(item2.data_inserimento)}
            </td>

            <td class={item2.cestino && "text-muted"}>        {item2.tutor && item2.tutor.cognome}
                    {item2.tutor != undefined && item2.tutor.nome}
            </td>
            <td class={item2.cestino && "text-muted"}>        {item2.admin && item2.admin.cognome}
                    {item2.admin != undefined && item2.admin.nome}
            </td>
            <td class={item2.cestino && "text-muted"}> {item2.indirizzo_S3 && <Button variant="outline-primary" onClick={() => ottieni_url(item2.indirizzo_S3)}>
                        <AiOutlineDownload />
                    </Button>}


            {!(item2.approvato || item2.cestino) &&    
                <Button variant="outline-danger" onClick={() => cancella_url(item2._id, true)}>
                <BsTrash />
                </Button>
            }
            {item2.cestino && Controlla_se_lavoro_in_debug(user) &&    
                <Button variant="outline-danger" onClick={() => cancella_url(item2._id, false)}>
                <TbTrashOff />
                </Button>
            }

            {item2.cestino && Controlla_se_lavoro_in_debug(user) &&    
                <Button variant="outline-danger" onClick={() => cancella_documento_definitivo(props.attore._id, item2._id)}>
                 <BsTrash />
                </Button>
            }


            {!item2.cestino &&  Controlla_se_lavoro_in_debug(user) && !item2.approvato && <Button variant="outline-primary" onClick={() => Approva_pdf(item2._id, true, props.tutor._id)}>
            <IoCheckmarkDoneOutline />
                </Button>}
            {Controlla_se_lavoro_in_debug(user) && item2.approvato && <Button variant="outline-primary" onClick={() => Approva_pdf(item2._id, false, props.tutor._id)}>
                    <IoArrowUndoOutline />
            </Button>}   

            {props.tipologia_documento.includes('File_word_rischio') && <Button variant="outline-primary" onClick={() => Prepara_certificati_formazione(item2.indirizzo_S3)}>
                    Prova Stampa 2
            </Button>} 
            </td>
        </tr>
        {lista_documentazione_temporanea_alunni && lista_documentazione_temporanea_alunni.map(function (item3, index2) {

            if (item3.indirizzo_s3_template_docx === item2.indirizzo_S3)  
            return <>
                    <tr>
                    <td>
                            {item3.cognome}
                        </td>
                
                        <td>
                            {item3.nome}
                        </td>
                        <td colSpan="3">
                            {item3.indirizzo}
                        </td>
                     
                        <td >
                        {item3.indirizzo !== undefined && <Button variant="outline-primary" onClick={() => ottieni_url(item3.indirizzo)}>
                                <AiOutlineDownload />
                            </Button>}
                        </td>



                    </tr>
            </>    
        })}
       
    
    </>
    }
    }
    }
    )
    }
    </>
    )
}
export default Visualizza_lista_documenti_pdf;